export { TurnCommentDialogComponent as CommentDialogComponent } from './components/turn.comment-dialog.component';
export { TurnDialogComponent as DialogComponent } from './components/turn.dialog.component';
export { TurnFormComponent as FormComponent } from './components/turn.form.component';
export { TurnComponent as MainComponent } from './components/turn.main.component';
export { TurnPatientSearchComponent as PatientSearchComponent } from './components/turn.patient-search-dialog.component';
